import {i18n} from 'mc/lib';

export const ZUK =  'ZUK';
export const UZAVIRKA =  'UZAVIRKA';
export const DZ =  'DZ';
export const PRIPOJENIKOMUNIKACE =  'PRIPOJENIKOMUNIKACE';
export const VYJIMKY =  'VYJIMKY';
export const STAVBNICINNOST =  'STAVBNICINNOST';
export const VRAKY =  'VRAKY';
export const PARKOVACIMISTA =  'PARKOVACIMISTA';

export const values = [
    ZUK,
    UZAVIRKA,
    DZ,
    PRIPOJENIKOMUNIKACE,
    VYJIMKY,
    STAVBNICINNOST,
    VRAKY,
    PARKOVACIMISTA,
];

const captions = {};

for (const value of values) {
    captions[value] = i18n('typUcel.' + value);
}

export function getCaption(value) {
    return captions[value] || '';
}
